import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";
import UserSettingsService from "src/services/userSettingsService";
import { makeStyles } from "tss-react/mui";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { useCurrentSubscriptionExpired, useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { Box, Theme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { ExpiredWrapper } from "@shared/ExpiredWrapper";

import PageHeader from "../shared/components/PageHeader";

import { Filter } from "./components/Filter";
import { StatisticSection } from "./components/StatisticSection/StatisticSection";
import { WorkspaceClaimSection } from "./components/WorkspaceClaimSection";

const useStyles = makeStyles()((theme: Theme) => ({
    filterContainer: {
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
    },
    contentBox: { marginTop: theme.spacing(3), width: "100%" },
    overviewContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        [theme.breakpoints.down("sm")]: {
            marginRight: theme.spacing(2),
        },
    },
}));

const OverviewPage = () => {
    const [filter, setFilter] = React.useState<number[]>(UserSettingsService.getOverviewPageGroupFilter());
    const { classes } = useStyles();
    const { t } = useTranslation(["pages", "common"]);

    const isExpired = useCurrentSubscriptionExpired();
    const { data: workspace, isLoading: isWorkspaceLoading } = useCurrentWorkspace();

    if (isWorkspaceLoading) {
        return null;
    }

    if (!workspace) {
        return (
            <PageContainer>
                <PageHeader
                    title={t("common:section.tutorial.title.yourWorkspace")}
                    description={t("common:section.tutorial.description.yourWorkspaceLead")}
                />
                <WorkspaceClaimSection />
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <div className={classes.filterContainer}>
                <PageHeader title={t("pages:overviewPage.title")} description={t("pages:overviewPage.description")} />
            </div>
            <ExpiredWrapper>
                <Box className={classes.overviewContainer}>
                    {!isExpired ? <Filter filter={filter} setFilter={setFilter} /> : null}
                    <Grid container spacing={1} className={classes.contentBox}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <StatisticSection {...{ filter }} />
                        </Grid>
                    </Grid>
                </Box>
            </ExpiredWrapper>
        </PageContainer>
    );
};

export default withMetaDescription(OverviewPage, {
    title: i18next.t("pages:overviewPage.metaTitle"),
    description: i18next.t("pages:overviewPage.metaDescription"),
});
